var frFrTranslation = {
    "contact_us.buttonText": "Aide",
    "contact_us.error.email": "Veuillez entrer une adresse email valide",
    "contact_us.error.general": "Oups... Il y a eu une erreur, merci de r\xe9essayer.",
    "contact_us.error.minimum_two_chars": "Doit comporter au moins 2 caract\xe8res",
    "contact_us.placeholders.email": "Adresse Email",
    "contact_us.placeholders.name": "Nom et Pr\xe9nom",
    "contact_us.placeholders.text": "Comment est-ce qu'on peut vous\xa0aider\xa0?",
    "contact_us.send": "Envoyer",
    "contact_us.subtitle": "Laissez-nous vos coordonn\xe9es, envoyez-nous votre question, et nous vous contacterons au plus vite",
    "contact_us.success.ok": "Ok",
    "contact_us.success.subtitle": "Message bien re\xe7u, nous vous r\xe9pondrons d\xe8s que possible",
    "contact_us.success.title": "Merci, {{name}}!",
    "contact_us.title": "Posez-nous vos\xa0questions\xa0!",
    "language.select.label": "S\xe9lectionnez votre langue",
    "cookie_consent.customize.categories.essential.description": "Ces cookies sont destin\xe9s \xe0 vous offrir la meilleure exp\xe9rience possible et sont indispensables au bon fonctionnement du site sans pour autant partager d'informations personnelles identifiables avec des tiers",
    "cookie_consent.customize.categories.essential.title": "Cookies essentiels (toujours activ\xe9s)",
    "cookie_consent.customize.categories.performance.description": "Ces cookies nous aident \xe0 mesurer les performances, \xe0 analyser les visites sur notre site afin de continuer \xe0 am\xe9liorer votre exp\xe9rience",
    "cookie_consent.customize.categories.performance.title": "Cookies analytiques",
    "cookie_consent.customize.confirm_btn_title": "Confirmer",
    "cookie_consent.customize.title": "Personnaliser les cookies",
    "cookie_consent.information.accept_btn_title": "accepter",
    "cookie_consent.information.cookies_policy_link_text": "Politique d’utilisation des cookies",
    "cookie_consent.information.customize_btn_title": "personnaliser",
    "cookie_consent.information.description": "Nous utilisons des cookies et d'autres technologies pour vous offrir la meilleure exp\xe9rience utilisateur possible et pour personnaliser la publicit\xe9 sur et hors de notre site web. De plus, nos partenaires peuvent utiliser des cookies ou d'autres technologies pour vous fournir des informations marketing. Si vous souhaitez d\xe9sactiver tous les cookies non essentiels, cliquez sur Personnaliser. Vous pouvez en apprendre plus sur notre politique en mati\xe8re de cookies et sur votre droit de refus dans notre politique d’utilisation des cookies.",
    "cookie_consent.information.title": "lemonade et les cookies",
    "cxai.browser_toast": "Pour une exp\xe9rience optimale, nous vous recommandons\nd'utiliser les navigateurs Chrome, Safari ou Edge",
    "cxai.default_description": "Votre assistant personel en assurance",
    "cxai.error.message": "Il y a eu un soucis...",
    "cxai.error.retry": "R\xc9ESSAYER",
    "cxai.phone_input.mobile_title": "",
    "cxai.phone_input.no_results": "",
    "cxai.phone_input.placeholder": "",
    "cxai.restart.action": "OUI",
    "cxai.restart.close": "NON",
    "cxai.restart.content": "Avez-vous besoin d’aide\npour autre chose ?",
    "cxai.restart.title": "Recommencer",
    "error_page.action": "Retour \xe0 l'accueil",
    "error_page.subtitle": "Nous n'avons pas trouv\xe9 la page que vous cherchez...",
    "error_page.title": "Oups.",
    "footer.disclaimer": "\xa0",
    "footer.titles.company": "Entreprise",
    "footer.titles.features": "A propos",
    "footer.titles.renters": "Locataires",
    "footer.titles.homeowners": "Propri\xe9taires",
    "footer.titles.get_app": "T\xe9l\xe9charger Lemonade",
    "footer.titles.products": "Produits",
    "footer.titles.resources": "Ressources",
    "footer.titles.social": "Suivez Lemonade",
    "footer.titles.contact": "Contactez nous",
    "header.actions.login": "Mon compte",
    "header.actions.logout": "D\xe9connexion",
    "header.actions.settings": "R\xe9glages",
    "header.accessibility.title": "Accessibilit\xe9",
    "header.api.title": "",
    "header.blank.title": "",
    "header.blog.title": "Blog",
    "header.car.title": "",
    "header.car_explained.title": "",
    "header.claims.title": "Remboursements",
    "header.community.title": "",
    "header.covid_19.title": "",
    "header.expats_de.title": "",
    "header.expats_nl.title": "",
    "header.faq.title": "FAQ",
    "header.giveback.title": "Giveback",
    "header.giveback_2021.title": "Giveback",
    "header.global_expansion.title": "Pr\xe9sence internationale",
    "header.home.title": "Accueil",
    "header.homeowners.title": "Propri\xe9taires",
    "header.imprint.title": "",
    "header.insurance_card.title": "",
    "header.insuropedia.title": "Dictionnaire Assurance",
    "header.investors.title": "",
    "header.legal_stuff.title": "Mentions l\xe9gales",
    "header.life.title": "",
    "header.makers.title": "On recrute !",
    "header.manage_cookies.title": "G\xe9rer les cookies",
    "header.partners_program.title": "",
    "header.personal_liability_hub.title": "",
    "header.pet.title": "",
    "header.pet_dog_insurance_explained.title": "",
    "header.pet_insurance.title": "",
    "header.policy_two.title": "Police 2.0",
    "header.privacy_policy.title": "Confidentialit\xe9",
    "header.renters.title": "Locataires",
    "header.renters_hub.title": "Conseils",
    "header.reviews.title": "",
    "header.sitemap.title": "Sitemap",
    "header.term_life.title": "",
    "header.terms_of_service.title": "Conditions g\xe9n\xe9rales",
    "header.transparency.title": "",
    "nav.accessibility.title": "Accessibilit\xe9",
    "nav.api.title": "",
    "nav.blank.title": "",
    "nav.blog.title": "Blog",
    "nav.car.title": "",
    "nav.car_explained.title": "",
    "nav.claims.title": "Remboursements",
    "nav.complaints.title": "R\xe9clamations",
    "nav.community.title": "",
    "nav.global_blog_fr.title": "Blog",
    "nav.covid_19.title": "",
    "nav.expats_de.title": "",
    "nav.expats_nl.title": "",
    "nav.faq.title": "FAQ",
    "nav.giveback.title": "Giveback",
    "nav.giveback_2021.title": "Giveback",
    "nav.global_expansion.title": "Pr\xe9sence internationale",
    "nav.assurance_habitation_locataire.title": "Assurance Habitation Locataire",
    "nav.assurance_responsabilit\xe9_civile.title": "Assurance Responsabilit\xe9 Civile",
    "nav.home.title": "Accueil",
    "nav.homeowners.title": "",
    "nav.guide_assurance_locataires.title": "Guide Assurance Locataires",
    "nav.assurance_habitation_pour_\xe9_tudiants.title": "Assurance Habitation Pour \xc9tudiants",
    "nav.prix_d_une_assurance_habitation.title": "Prix D’Une Assurance Habitation",
    "nav.assurance_scolaire.title": "Assurance Scolaire",
    "nav.attestation_d_assurance_habitation.title": "Attestation d'assurance Habitation",
    "nav.assurance_t\xe9l\xe9phone.title": "Assurance T\xe9l\xe9phone",
    "nav.paiement_assurance_habitation.title": "Paiement Assurance Habitation",
    "nav.assurance_habitation.title": "Assurance Habitation",
    "nav.en_quoi_notre_assurance_est_diff\xe9rente.title": "En Quoi Notre Assurance Est Diff\xe9rente",
    "nav.propri\xe9taires_occupants.title": "Propri\xe9taires Occupants",
    "nav.propri\xe9taires_non_occupants.title": "Propri\xe9taires Non-Occupants",
    "nav.locations_saisonni\xe8res.title": "Locations Saisonni\xe8res",
    "nav.imprint.title": "",
    "nav.insurance_card.title": "",
    "nav.insuropedia.title": "Dictionnaire Assurance",
    "nav.investors.title": "",
    "nav.legal_stuff.title": "Mentions l\xe9gales",
    "nav.life.title": "",
    "nav.makers.title": "On recrute !",
    "nav.manage_cookies.title": "G\xe9rer les cookies",
    "nav.partners_program.title": "",
    "nav.personal_liability_hub.title": "",
    "nav.pet.title": "",
    "nav.pet_dog_insurance_explained.title": "",
    "nav.pet_insurance.title": "",
    "nav.policy_two.title": "Police 2.0",
    "nav.privacy_policy.title": "Confidentialit\xe9",
    "nav.renters.title": "",
    "nav.renters_hub.title": "Conseils",
    "nav.reviews.title": "",
    "nav.sitemap.title": "Sitemap",
    "nav.term_life.title": "",
    "nav.terms_of_service.title": "Conditions g\xe9n\xe9rales",
    "nav.transparency.title": "",
    "privacy_banner.content": "Nous utilisons des cookies et d'autres technologies pour vous offrir la meilleure exp\xe9rience utilisateur possible et pour personnaliser la publicit\xe9 sur et hors de notre site web. En outre, nos partenaires peuvent utiliser des cookies ou d'autres technologies pour vous fournir des informations commerciales. Pour en savoir plus \xe0 ce sujet et sur votre droit de refus, consultez notre [politique de confidentialit\xe9](privacyPolicyLink).",
    "privacy_banner.cta": "J'accepte",
    "cookie_consent.information.reject_btn_title": "Refuser",
    "cookie_consent.customize.categories.tracking.title": "Cookies de ciblage/publicit\xe9",
    "cookie_consent.customize.categories.tracking.description": "Il s'agit de cookies marketing qui nous aident \xe0 proposer les offres les plus personnalis\xe9es",
    "nav.do_not_share_my_personal_information.title": "Ne pas partager mes informations personnelles",
    "cookie_consent.customize.personalInfo.block3.description": "Si vous avez un compte chez nous et souhaitez modifier ou supprimer vos donn\xe9es, envoyez-nous un email \xe0 l'adresse privacy@lemonade.com ou appelez-nous au num\xe9ro gratuit 844-733-8666",
    "cookie_consent.customize.personalInfo.block1.description": "Nous utilisons les informations collect\xe9es par les cookies pour vous offrir la meilleure exp\xe9rience possible. Mais ne vous inqui\xe9tez pas, vous pouvez vous y opposer \xe0 tout moment. En tant que r\xe9sident californien, vous avez des droits concernant la vente d'informations personnelles."
};

export { frFrTranslation as default };
